import serviceAPI from '../../api/serviceAPI';
import reportAPI from '../../api/reportAPI';
import storage from 'storejs';

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        // 查询banner列表
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         */
        async addVote(context, params) {
            try {
                const lists = await serviceAPI.addVote(params);
                return lists;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 查询banner列表
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         */
        async detailCL(context, params) {
            try {
                const lists = await serviceAPI.detailCL(params);
                return lists;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 查询banner列表
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         */
        async getZJlist(context, params) {
            try {
                const lists = await serviceAPI.getZJlist(params);
                return lists;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 查询banner列表
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         */
        async uploadImg(context, params) {
            try {
                const lists = await serviceAPI.uploadImg(params);
                return lists;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 查询banner列表
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         */
        async saveCL(context, params) {
            try {
                const lists = await serviceAPI.saveCL(params);
                return lists;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 查询banner列表
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         */
        async queryBannerLists(context, params) {
            try {
                const lists = await serviceAPI.queryBannerLists(params);
                return lists;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 上传图片
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         * @param {Object} params.data-图片数据base64
         * @param {Object} params.fileName-图片name
         */
        async uploadFile(context, params) {
            try {
                const data = await serviceAPI.uploadFile(params);
                return data;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 收藏文章
        /**
         * @param {Object} params-请求参数
         * @param {String} params.code-code
         * @param {Number} params.type--0:评论点赞 1:文章 2:会议 3:视频 4:精彩回顾 5:病例大赛 6:病例展示 8:语音
         */
        async addCollection(context, params) {
            try {
                const comments = await serviceAPI.addCollection(params);
                return comments;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 取消收藏文章
        /**
         * @param {Object} params-请求参数
         * @param {String} params.code-code
         * @param {Number} params.type--0:评论点赞 1:文章 2:会议 3:视频 4:精彩回顾 5:病例大赛 6:病例展示 8:语音
         */
        async cancelCollection(context, params) {
            try {
                const comments = await serviceAPI.cancelCollection(params);
                return comments;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 给文章点赞
        /**
         */
        async setPraise(context, params) {
            try {
                const article = await serviceAPI.setPraise(params);
                return article;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 上报用户访问时长
        /**
         * @param {Object} params-请求参数
         * @param {String} params.type-1、文章 2、会议 3、视频 4、精彩回顾 5、每日一听
         * @param {String} params.code-CODE
         * @param {String} params.logType-1、停留时长 2、播放时长
         * @param {String} params.viewId-访问ID 备注:此参数 文章，会议，视频，精彩回顾，病例大赛，病历展示
         */
        async reportUserTime(context, params) {
            try {
                const data = await reportAPI.reportUserTime(params);
                return data;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        /**
         * 上报新增积分
         */
        async upReported(context, params) {
            try {
                const data = await reportAPI.upReported(params);
                return data;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 添加评论
        /**
         */
        async sendMessage(context, params) {
            try {
                const sendRes = await serviceAPI.sendMessage(params);
                return sendRes;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        // 查询收藏列表
        /**
         * @param {Object} params-请求参数
         * @param {String} params.companyCode-公司编码
         * @param {Number} params.areaCode-专区编码
         * @param {Number} params.pageNum-模块页码
         * @param {Number} params.pageSize-模块页数
         * @param {Number} params.userId-用户id
         */
        async queryCollectLists(context, params) {
            try {
                const lists = await serviceAPI.queryCollectLists(params);
                return lists;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },

        //  直播报名
        /**
         */
        async addRegLive(context, params) {
            try {
                const article = await serviceAPI.addRegLive(params);
                return article;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },
        // 上报按钮点击
        //
        // PageName
        // EventID
        // ControlName 控件名称
        // Description
        // ActionType

        /**
        *  埋点上报接口服务   from Min in 2018/8/9
        *  UserID用户id            用户userId
        *  Access访问来源          其值为进入专区首页链接地址拿到的 Access 参数
        *  DeviceTime             获取当前时间戳
        *  CompanyCode/AreaCode   公司code/专区code
        *  PageID/PageName        页面id/name    1、首页  2、资讯精选  3、名家讲坛  4、喂养实践  5、会议速递   501、会议快讯  502、会议预告  6、搜索页面
                                                  7、个人中心   8、设置个人信息   9、文章详情    10、视频详情  11、会议详情   12、外链
        *  EventID 事件id         事件id         1、页面加载事件 onload   2、点击事件 onclick
        *  Description            描述           首页访问来源埋点/ 全点击事件埋点
        *  ActionType             动作类型       1、首页访问来源埋点      2、全点击事件埋点
        *  ActionName             动作名         pv
        *  ActionObj              动作对象       主要阵对点击事件，页面加载事件给''
        *  AppVersion/ MobileModel/MobileSystemModel  获取设备信息
        */
        async baoSaveReport(context, params) {
            try {
                const data = await reportAPI.baoSaveReport(params);
                return data;
            } catch (error) {
                // 抛出异常
                throw error;
            }
        },
    },
};


// WEBPACK FOOTER //
// ./src/store/modules/content.js